module.exports = __webpack_public_path__ + "img/meeting_ended_icon.6afd5fbc.svg";